import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
import { RatingLayout } from './rating-layout';
import { BaseButton } from '../button';
/**
 * Компонент `<Rating/>` отображает информацию о рейтинге в виде набора звездочек.
 * @example
 * ```jsx
 *  <Rating
      hasLink
      value={5}
      color="brand-primary"
      href="https://leroymerlin.ru/">
      leroymerlin.ru
    </Rating>
 * ```
 */

export const Rating = ({
  className,
  hasLink,
  size = 'm',
  value,
  color,
  labelVariant,
  withExtraClickZone,
  children,
  ...props
}) => {
  const rateClassname = useMemo(() => clsx(styles.ratingContent, styles[size], {
    [styles.link]: hasLink,
    [styles.extraClickZone]: hasLink && withExtraClickZone
  }, className), [size, className, hasLink, withExtraClickZone]);

  if (hasLink) {
    return /*#__PURE__*/React.createElement(BaseButton, {
      className: rateClassname,
      ...props
    }, /*#__PURE__*/React.createElement(RatingLayout, {
      value: value,
      labelVariant: labelVariant,
      color: color
    }, children));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: rateClassname,
    ...props
  }, /*#__PURE__*/React.createElement(RatingLayout, {
    value: value,
    labelVariant: labelVariant,
    color: color
  }, children));
};